// extracted by mini-css-extract-plugin
module.exports = {"button":"Feuatures_button__6Ovpt"};